import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from "react-native";
import { Box, coreTheme } from "@kolmeo/ui-core";
const { palette } = coreTheme;
const Divider = ({ ...props }) => {
    return _jsx(Box, { height: StyleSheet.hairlineWidth, width: "100%", backgroundColor: palette.borderLight, ...props });
};
export default Divider;
